import { Redacted, Schema } from "effect";
import { WorkspaceFiles } from "@workerstation/shared/station/workspace-input";
import { privateDependencyFailure } from "@workerstation/shared/errors/private-cause";

export const EditorDocumentHydration = Schema.Struct({
  sequence: Schema.Int, workspaceId: Schema.String,
  files: WorkspaceFiles, folders: Schema.Array(Schema.String)
});
export type EditorDocumentHydration = typeof EditorDocumentHydration.Type;
export interface EditorDocumentIdentity {
  readonly workspaceId: string | null;
  readonly generation: number;
}
export interface EditorDocumentSnapshot extends EditorDocumentIdentity {
  readonly hydrationSequence: number;
  readonly revision: number;
  readonly files: Readonly<Record<string, string>>;
  readonly folders: readonly string[];
  readonly closed: boolean;
}
export class EditorDocumentInputFailure extends Schema.TaggedError<EditorDocumentInputFailure>()("EditorDocumentInputFailure", {}) {}
export class EditorDocumentDependencyFailure extends privateDependencyFailure<EditorDocumentDependencyFailure>()("EditorDocumentDependencyFailure", "editor document") {}
export const editorDocumentDependencyFailure = (cause: unknown) => new EditorDocumentDependencyFailure({ cause: Redacted.make(cause) });
export type EditorDocumentFailure = EditorDocumentInputFailure | EditorDocumentDependencyFailure;
export type EditorFilesUpdate = Readonly<Record<string, string>> | ((current: Readonly<Record<string, string>>) => Readonly<Record<string, string>>);
export type EditorFoldersUpdate = readonly string[] | ((current: readonly string[]) => readonly string[]);
